import StorageHelper from '@/utils/storage-helper';
import Cookies from 'js-cookie';
import isPlainObject from 'lodash/isPlainObject';

const PLY_UTM_PARAMS_COOKIE_KEY = 'ply-website-utm-params';
const PLY_UTM_PARAMS_COOKIE_KEY_WRAPPED = StorageHelper.wrapKey(PLY_UTM_PARAMS_COOKIE_KEY);

// Private
const getPlyWebsiteCookieUtmAndRefParams = () => {
	const utmParamsFromWebsiteStringified = Cookies.get(PLY_UTM_PARAMS_COOKIE_KEY_WRAPPED);
	if (utmParamsFromWebsiteStringified) {
		try {
			return JSON.parse(utmParamsFromWebsiteStringified);
		} catch {
			console.error('utmParams from cookies were malformed', utmParamsFromWebsiteStringified);
		}
	}
	return {};
};

// Public

/***
 * combines both utm params received in query and those that were received on ply-website
 * utm params received from query takes precedence over those received from cookie
 * @param {Object} query
 * @param {boolean} includeCookieUtmParams
 * @returns {Object} utmParams
 * @example
 * const query = {
 * 	utm_source: 'google',
 * 	utm_medium: 'cpc',
 * 	utm_campaign: 'ply-website',
 * 	utm_content: 'ply-website-sign-up',
 * 	non_u-t-m_key: 'non_utm_value',
 * };
 * const utmParams = getReferralAndUtmParams(query);
 * console.log(utmParams);
 * // {
 * // 	utm_source: 'google',
 * // 	utm_medium: 'cpc',
 * // 	utm_campaign: 'ply-website',
 * // 	utm_content: 'ply-website-sign-up',
 * // }
 */
const getReferralAndUtmParams = (query, includeCookieUtmParams = true) => {
	const utmParams = {};
	if (includeCookieUtmParams) {
		const cookieUtmParams = getPlyWebsiteCookieUtmAndRefParams();
		Object.assign(utmParams, cookieUtmParams);
	}
	// verifies that query is an object and not an array and not null
	if (query && isPlainObject(query)) {
		const queryUtmParams = Object.fromEntries(Object.entries(query).filter(([key]) => key.startsWith('utm_')));
		Object.assign(utmParams, queryUtmParams);
	}
	return utmParams;
};

const clearPlyWebsiteCookieUtmParams = () => Cookies.remove(PLY_UTM_PARAMS_COOKIE_KEY_WRAPPED, { domain: 'ply.io' });

const SignUpService = {
	getReferralAndUtmParams,
	clearPlyWebsiteCookieUtmParams,
};

export default SignUpService;
